import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchBudget } from "containers/Budget/_actions";

export function useAnalysis(farmId, analysisId) {
    const dispatch = useDispatch();

    const analysis = useSelector((state) => {
        const offlineFarm = state.offlineFarms.find((f) => f.id === farmId);
        const farm = offlineFarm ? offlineFarm.farm : null;
        const offlineBudget = farm ? (farm.offlineBudgets || []).find((ob) => ob.id === analysisId && ob.isDownloaded) : null;
        return offlineBudget ? offlineBudget.budget : null;
    });

    useEffect(() => {
        if (!analysis && farmId && analysisId) {
            dispatch(fetchBudget(farmId, analysisId));
        }
    }, [farmId, analysisId, analysis, dispatch]);

    return analysis;
}
